<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="pageTitle"
            :button="activeMenu == 'consultant'"
            :button-text="$t('page.rav_consultant.new')"
            :button-route="{ name: 'rav_consultant_new', params: { ravId: rav.id }}"
            back
            back-to="rav"
        />
        <v-row>
            <v-col cols="12">
                <TabMenu
                    :menus="menus"
                    v-model="activeMenu"
                />
            </v-col>
            <v-col cols="12">
                <v-alert
                    v-for="(error, errorKey) in generalFormErrors"
                    :key="errorKey"
                    type="error"
                    v-text="error"
                />
                <RavForm
                    v-if="activeMenu == 'profile'"
                    :rav="rav"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :loading="loading"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
                <RavConsultants
                    v-if="activeMenu == 'consultant'"
                    :rav-id="$route.params.id"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import RavForm from '@/components/rav/Form/RavForm';
import RavConsultants from '@/components/rav/RavConsultants';
import TabMenu from '@/components/common/TabMenu';
import RavProxy from '@/proxies/RavProxy';
import { SuccessSnackbar, StandBy } from '@/app-events.js';

export default {
    name: 'RavDetail',
    components: {
        PageHeader,
        RavForm,
        RavConsultants,
        TabMenu,
    },
    created() {
        this.fetchData();
    },
    data() {
        return {
            activeMenu: 'profile',
            menus: [
                {
                    id: 'profile',
                    label: 'Profil',
                },
                {
                    id: 'consultant',
                    label: this.$t('rav.consultant'),
                },
            ],
            loading: false,
            rav: {},
            rawData: {},
        };
    },
    computed: {
        pageTitle() {
            return this.rawData.name;
        },
        breadcrumbs() {
            return [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.rav.title'),
                    exact: true,
                    to: { name: 'rav' },
                },
                {
                    text: this.pageTitle,
                    disabled: true,
                },
            ];
        },
    },
    methods: {
        fetchData() {
            this.loading = true;
            new RavProxy().find(this.$route.params.id).then(({ data }) => {
                this.rav = data.data;
                this.rawData = JSON.parse(JSON.stringify(this.rav));
                this.loading = false;
            }).catch(({ data }) => {
                this.displayError(data);
            });
            
        },
        resetObject() {
            this.rav = JSON.parse(JSON.stringify(this.rawData));
            this.resetErrors();
        },
        saveObject() {
            this.$eventBus.dispatch(new StandBy(true));
            const formData = {
                rav_location: {
                    name: this.rav.name,
                    address: this.rav.address,
                    city: this.rav.city,
                    zip: this.rav.zip,
                    canton: this.rav.canton.code,
                    phone: this.rav.phone,
                    fax: this.rav.fax,
                    email: this.rav.email,
                    website: this.rav.website,
                },
            };
            new RavProxy().update(this.$route.params.id, formData).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.rawData = JSON.parse(JSON.stringify(this.rav));
                this.$eventBus.dispatch(new SuccessSnackbar(this.$t('rav.actions.saved')));
                this.resetErrors();
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        },
    },
};
</script>
